import { initializeApp, deleteApp } from 'firebase/app';
import type { Auth } from 'firebase/auth';
import { SAMLAuthProvider, getAuth, getRedirectResult, signInWithPopup, signInWithRedirect } from 'firebase/auth';
const empty: <T>() => T | undefined = () => undefined;

export const firebaseApp = {
  _app: empty<ReturnType<typeof initializeApp>>(),

  async initialize(options?: { authDomain: string }) {
    const o = {
      apiKey: 'AIzaSyD-mGRXlVBuGhEPIKMeFfBC3FhYzJBxswk',
      projectId: 'production-recruiter-app',
      authDomain: 'production-recruiter-app.firebaseapp.com',
      ...options,
    };
    if (this._app && this._app.options.authDomain !== o.authDomain) {
      await deleteApp(this._app);
      this._app = undefined;
    }
    this._app ??= initializeApp(o);
    return this;
  },

  get app() {
    if (!this._app) throw new Error('Missing call to initialize.');
    return this._app;
  },
  getAuth() {
    return getAuth(this.app);
  },
  getSaml(pid: string): [Auth, SAMLAuthProvider] {
    return [this.getAuth(), new SAMLAuthProvider(pid)];
  },
  async signInWithPopup(pid: string) {
    return await signInWithPopup(...this.getSaml(pid));
  },
  async signInWithRedirect(pid: string) {
    return await signInWithRedirect(...this.getSaml(pid));
  },
  getRedirectResult() {
    return getRedirectResult(this.getAuth());
  },
  async currentUser() {
    const auth = this.getAuth();
    await auth.authStateReady();
    return auth.currentUser;
  },
};
